<template>
  <v-tooltip
    v-model="tooltipVisible"
    class="copy-button t-copy"
    right
    :disabled="!tooltipVisible"
    style="position: relative; top: -1px"
  >
    <v-btn
      slot="activator"
      flat
      icon
      :ripple="false"
      @click="copyData"
    >
      <v-icon
        size="18"
        v-text="icon"
      />
    </v-btn>

    <span>Copied to clipboard</span>
  </v-tooltip>
</template>

<script>
  import flashMessages from '@/mixins/flashMessages'

  export default {
    name: 'CopyButton',
    mixins: [flashMessages],
    props: {
      value: {
        required: true,
        type: [String, Number]
      },
      icon: {
        required: false,
        type: String,
        default: 'file_copy'
      }
    },
    data () {
      return {
        tooltipVisible: false
      }
    },
    methods: {
      copyData () {
        navigator.clipboard.writeText(this.value).then(() => {
          this.tooltipVisible = true

          setTimeout(() => {
            this.tooltipVisible = false
          }, 6000)
        }).catch(() => {
          this.showErrorFlashMessage('Copy failed')
        })
      }
    }
  }
</script>

<style lang="scss">
  .copy-button {
    position: relative;
    top: -1px;

    .v-btn  {
      width: 20px;
      height: 20px;
      color: #bdbdbd;
      transition: none;
      margin: 0 4px;

      &::before {
        transition: none;
      }

      &:hover {
        color: #757575;

        &::before {
          background-color: transparent;
        }
      }

      &:focus::before {
        background-color: transparent;
      }
    }
  }
</style>
